export default __webpack_public_path__ + "static/media/Monk's Belt of the Nine Springs.f145ac27.jpg";